import { useQuery } from '@tanstack/react-query';
import { api } from '@/auth/api';
import { isTenantAdminHost } from '@/config';

/**
 * FAD A3: the fleet whose admin runs on this hostname. Only fetched on
 * tenant admin hosts (admin.<zone>) — central and dev never ask. Public
 * endpoint: the login page themes itself with this before any sign-in.
 */
export interface AdminHostTenant {
  fleetId: string;
  fleetName: string;
  poweredBy: true;
  brand: {
    name: string;
    primaryHex: string | null;
    accentHex: string | null;
    logoUrl: string | null;
  };
}

export function useAdminHostTenant() {
  return useQuery({
    queryKey: ['admin-host', 'tenant'],
    enabled: isTenantAdminHost(),
    queryFn: () => api<AdminHostTenant>('/v1/admin-host/tenant'),
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
